<template>
  <v-container>
    <v-card>
      <component v-bind:is="'Cookies' + activeLocale.toUpperCase()" />
    </v-card>
  </v-container>
</template>

<script>
import CookiesCZ from '../components/Cookies/Cookies-cz';
import CookiesEN from '../components/Cookies/Cookies-en';
export default {
  name: 'CookiePolicy',
  components: {
    CookiesCZ,
    CookiesEN
  },
  data() {
    return {
      activeLocale: 'cz'
    }
  },
  mounted() {
    this.activeLocale = this.$i18n.locale;
  },
  watch: {
    "$i18n.locale": function (val) {
      this.activeLocale = val;
    },
  }
}
</script>
